<template>
    <div class="consent-edit panel">
        <div class="grid grid-3 grid-center">
            <div>
                <span 
                    v-bastards
                    class="text-bold fs-18"
                    v-text="`${label}:`"
                />
            </div>
            <div class="consent-edit-input flex flex-content-start">
                <label 
                    v-bastards
                    class="text-bold fs-18"
                    v-text="`${inputLabel}:`"
                />
                <Component 
                    v-if="inputComponent"
                    v-model="value"
                    :is="inputComponent" 
                    :is-required="true"
                    ref="inputComponent"
                    @input="onInput"
                />
            </div>
            <div class="flex flex-content-center">
                <RadioGroup
                    :name="label"
                    :selected="isGranted ? 1 : 0"
                    :options="[
                        {
                            label: 'Tak',
                            value: 1
                        },
                        {
                            label: 'Nie',
                            value: 0
                        }
                    ]"
                    @change="onChangeGranted"
                />
            </div>
        </div>
        <ConsentCancellation
            v-model="cancellationReason"
            ref="consentCancellation"
            :is-open="!isGranted"
            :label="label"
            :causes="causes"
            @changeMind="onChangeCancellation"
        />
    </div>
</template>

<script>
import ConsentCancellation from '@/components/consent/ConsentCancellation'
import InputEmail from '@/components/form/InputEmail'
import InputPhone from '@/components/form/InputPhone'
import RadioGroup from '@/components/form/RadioGroup'

export default {
    components: {
        ConsentCancellation,
        InputEmail, 
        InputPhone,
        RadioGroup
    },

    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            required: true,
            default: 0
        },
        inputLabel: {
            type: String,
            required: false,
            default: ''
        },
        name: {
            type: String,
            required: false,
            default: ''
        },
        inputType: {
            type: String,
            required: false,
            validator(value) {
                return value === 'email' || value === 'phone'
            }
        },
        inputValue: {
            type: String,
            required: false,
            default: ''
        },
        isChecked: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            value: this.inputValue,
            isGranted: this.isChecked,
            cancellationReason: {
                value: 0,
                label: ''
            }
        }
    },

    computed: {
        causes() {
            let out = this.$store.getters['consentsResolver/resignationReasons']

            if (!out) {
                return ['Ładuję...']
            }
                
            const match = out.filter(item => item.name === this.name)

            if (match) {
                return match[0].resignationReasons
            }

            return ['Ładuję...']
        },

        inputComponent() {
            const inputComponentsMap = {
                email: InputEmail,
                phone: InputPhone
            }

            if (!inputComponentsMap.hasOwnProperty(this.inputType)) {
                return null
            }

            return this.inputType
                ? inputComponentsMap[this.inputType]
                : null
        }
    },

    watch: {
        isChecked(value) {
            this.isGranted = value
        },

        inputValue: {
            handler: function (value) {
                console.log(value)
            }
        },

        cancellationReason: {
            handler: function (value) {
                console.log(value)
                this.updateStoreStatus()
            },
            deep: true
        }
    },

    methods: {
        onChangeGranted(value) {
            this.isGranted = value

            this.updateStoreStatus()
        },

        onChangeCancellation(value) {
            if (!value) {
                this.isGranted = true
            }
        },

        onInput() {
            this.updateStoreStatus()
        },

        updateStoreStatus() {
            const result = this.$store.dispatch('consentsResolver/updateManageableConsent', {
                type: this.type,
                value: this.value,
                isGranted: this.isGranted,
                resignationReason: this.isGranted ? '' : this.cancellationReason.value,
                resignationReasonOther: !this.isGranted && this.cancellationReason.value === 0 ? this.cancellationReason.label : ''
            })

            if (!result) {
                alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem systemu.")
            }
        },
        
        validate() {
            return (this.isGranted && this.$refs.inputComponent.validate()) || (!this.isGranted && this.$refs.consentCancellation.validate())
        }
    }
}
</script>

<style lang="scss">
.consent-edit {
    padding: 0 52px;

    .is-ie & {
        min-height: 110px;
        padding-top: 36px;

        &-input {
            margin-right: 50px !important;

            > * {
                display: inline-block;
                vertical-align: middle;
            }

            > [class^="input-"] {
                width: 270px;

                input {
                    width: 270px;
                }
            }
        }
    }

    & + & {
        margin: 17px 0 0;
    }

    > .grid {
        min-height: 110px;
    }

    &-input {
        > label {
            min-width: 83px;
        }

        > [class^="input-"] {
            width: 100%;

            input {
                border: 1px solid $color-border;
                padding: 10px 20px;
                text-align: left;
            }
        }
    }

    @media (max-width: $screen-laptop) {
        padding: 0 30px;
    }

    @media (max-width: $screen-tablet) {
        > .grid {
            display: block;
            grid-column-gap: 10px;
            padding-bottom: 20px;

            > * {
                padding: 20px 0 0;
            }
        }
    }
}
</style>
